import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failedMethods = [{
  title: '"Piensa en positivo"',
  description: 'Tu amígdala no habla el idioma del pensamiento racional. Cuando está activada, es sorda a la lógica.'
}, {
  title: '"Medita 20 minutos"',
  description: '¿En serio? ¿Cuándo? ¿Y cómo te sientas en silencio cuando tu cerebro suena como una alarma de incendio?'
}, {
  title: '"Habla con alguien"',
  description: 'La terapia es valiosa, pero no está disponible a las 3:47 PM cuando la crisis llega.'
}, {
  title: '"Toma suplementos"',
  description: 'Sin un sistema que los respalde, son solo pastillas con esperanza.'
}];
export function WhyMethodsFail() {
  return <section className="w-full bg-[#FDF8F4]/80 py-16 md:py-24" data-id="element-174">
      <div className="max-w-4xl mx-auto px-6" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-176">
          <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-6 text-center" data-id="element-177">
            Por Qué los Métodos Tradicionales No Funcionan
          </h2>
          <p className="font-inter text-lg text-charcoal/80 mb-12 text-center max-w-2xl mx-auto" data-id="element-178">
            El problema con la mayoría de los consejos sobre ansiedad es que
            atacan el problema equivocado.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-179">
          {failedMethods.map((method, index) => <motion.div key={index} className="bg-white rounded-xl p-6 border-2 border-charcoal/10" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-180">
              <div className="flex items-start gap-4" data-id="element-181">
                <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-182" />
                <div data-id="element-183">
                  <h3 className="font-lora text-xl font-semibold text-charcoal mb-2" data-id="element-184">
                    {method.title}
                  </h3>
                  <p className="font-inter text-charcoal/80" data-id="element-185">
                    {method.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div className="mt-12 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-186">
          <p className="font-inter text-xl text-charcoal font-semibold max-w-2xl mx-auto" data-id="element-187">
            La verdad es esta: ninguno de estos métodos llega al origen del
            problema. Todos intentan convencer a la mente de algo que el cuerpo
            ya decidió.{' '}
            <span className="text-sage" data-id="element-188">Y el cuerpo siempre gana.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}